"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionIcon = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var HexagonAlertBase_1 = require("./HexagonAlertBase");
var HexagonPauseBase_1 = require("./HexagonPauseBase");
var HexagonStopBase_1 = require("./HexagonStopBase");
var ExceptionIcon = function (_a) {
    var config = _a.config, currentException = _a.currentException;
    if (currentException.type.category === 'Action Required') {
        return (0, jsx_runtime_1.jsx)(HexagonStopBase_1.HexagonStopBase, { config: config });
    }
    else if (currentException.type.category === 'Shipment Hold') {
        return (0, jsx_runtime_1.jsx)(HexagonPauseBase_1.HexagonPauseBase, { config: config });
    }
    return (0, jsx_runtime_1.jsx)(HexagonAlertBase_1.HexagonAlertBase, { config: config });
};
exports.ExceptionIcon = ExceptionIcon;
